import { render, staticRenderFns } from "./DirectorActions.vue?vue&type=template&id=137de80a"
import script from "./DirectorActions.vue?vue&type=script&lang=js"
export * from "./DirectorActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports